import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getNavNeededState } from '@sharedCR/common/NavNeededIndicator/NavNeededIndicator.utils';

import { getConditionalObject } from 'utils/data';

import { selectIncompleteLinkedNavByEntity } from 'store/loanApplications/selectors';

import { AREA_ID_BY_TABLE_NAME } from '../TableWrapper/TableWrapper.constants';

const useNeededCountByRecord = (tableName, records) => {
  const navNeededByEntity = useSelector(selectIncompleteLinkedNavByEntity());

  const areaIds = useMemo(() => {
    const areaId = AREA_ID_BY_TABLE_NAME[tableName];

    return areaId ? [areaId] : [];
  }, [tableName]);

  return useMemo(
    () =>
      (records ?? []).reduce((acc, { id }) => {
        const { count } = id ? getNavNeededState(navNeededByEntity[id], areaIds) : { count: 0 };

        return { ...acc, ...getConditionalObject(count, () => ({ [id]: count })) };
      }, {}),
    [records, navNeededByEntity, areaIds],
  );
};

export default useNeededCountByRecord;
